import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Shield, ExternalLink } from 'lucide-react';
import { EMPRESAS_ASOCIADAS, trackClick } from './constants';

const PartnerCard = ({ empresa, index }) => (
  <Card data-testid={`partner-card-${index}`} className="bg-white/80 backdrop-blur-md border-0 shadow-xl rounded-2xl overflow-hidden group hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2">
    <div className={`h-2 bg-gradient-to-r ${empresa.color}`}></div>
    <CardHeader className="text-center pb-6">
      <div className="mx-auto mb-6 p-4 bg-white rounded-2xl shadow-lg w-fit group-hover:scale-110 transition-transform duration-300">
        <img
          src={empresa.logo}
          alt={`${empresa.nombre} logo`}
          className="h-16 w-auto max-w-[180px] mx-auto object-contain"
          onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }}
        />
        <div className="hidden items-center justify-center h-16 w-16 bg-blue-100 rounded-2xl">
          <Shield className="h-8 w-8 text-blue-600" />
        </div>
      </div>
      <CardTitle className="text-xl font-bold text-slate-800 mb-2">{empresa.nombre}</CardTitle>
      <p className="text-slate-600">{empresa.descripcion}</p>
    </CardHeader>
    <CardContent className="px-6 pb-6">
      <div className="space-y-3 mb-6">
        {empresa.beneficios.map((beneficio) => (
          <div key={beneficio} className="flex items-center space-x-3">
            <div className="w-2 h-2 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full"></div>
            <span className="text-slate-700 font-medium">{beneficio}</span>
          </div>
        ))}
      </div>
      <Button
        data-testid={`partner-quote-btn-${index}`}
        className={`w-full bg-gradient-to-r ${empresa.color} text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300`}
        onClick={() => { trackClick(empresa.nombre); window.open(empresa.link, '_blank'); }}
      >
        <ExternalLink className="h-4 w-4 mr-2" />
        Cotizar ahora
      </Button>
    </CardContent>
  </Card>
);

export const PartnersSection = () => (
  <section className="py-20 bg-gradient-to-br from-slate-50 to-blue-50" data-testid="partners-section">
    <div className="container mx-auto px-4">
      <div className="text-center mb-16">
        <h3 className="text-4xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent mb-4">Nuestros Aliados Digitales</h3>
        <p className="text-xl text-slate-600 max-w-2xl mx-auto">Tecnología de vanguardia con las mejores compañías de seguros</p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-testid="partners-grid">
        {EMPRESAS_ASOCIADAS.map((empresa, index) => <PartnerCard key={empresa.nombre} empresa={empresa} index={index} />)}
      </div>
    </div>
  </section>
);

export default PartnersSection;
